module.exports = __webpack_public_path__ + "/images/ico-color-gratuit.1ce5cca.svg";